export const SEND_AKTS_UI = 'SEND_AKTS_UI';
export const GET_COUNTERPARTY_INFO_UI = 'GET_COUNTERPARTY_INFO_UI';
export const COUNTERPARTIES_UI = 'COUNTERPARTIES_UI';
